import request from '@/services/interceptor.js'

export const get_incassi = (filtri) => {
    return request({
        url: '/incasso',
        method: 'get',
        params: filtri || {},
        loadingBar: true
    })
}

export const get_incasso = (id) => {
    return request({
        url: `/incasso/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_incasso = (par) => {
    return request({
        url: '/incasso',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_incasso = (id, par) => {
    return request({
        url: `/incasso/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const completa_incasso = (id, par) => {
    return request({
        url: `/incasso/${id}/completa`,
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const duplica_incasso = (id) => {
    return request({
        url: `/incasso/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const elimina_incasso = (id) => {
    return request({
        url: `/incasso/${id}`,
        method: 'delete',
        loadingBar: true
    })
}
